import React, {useEffect, useMemo, useRef, useState} from 'react';
import gsap from "gsap";


const Toggle = ({handleLangChange, lang}) => {

    const [active, setActive] = useState(0);
    const el = useRef()


    const toggle = () => {
        setActive(active === 0 ? 1 : 0);
        handleLangChange()

    }

    useEffect(() => {
            setActive(lang === 'es' ? 1 : 0);

    },[lang])


    useEffect(() => {
        gsap.to(el.current, {
            x: active ? '2rem' : '-0rem',
            duration: 0.25,
        })

    }, [active])

    return (<div className="toggle-el" onClick={toggle}>
        <div className="lang-labels">
            <div className={"lang-label " + (!active ? "active" : "")}>EN</div>
            <div className={"lang-label " + (!active ? "" : "active")}>ES</div>
        </div>

        <div ref={el} className=" notch ">
            <span/>
        </div>
    </div>)
}


export default Toggle;


// import React, {useState} from 'react';
// import Anime from 'react-anime';
//
//
// const Toggle = () => {
//
//
//     const [active, setActive] = useState(0);
//
//     const toggle = () => {
//         setActive( active === 0 ? 1 : 0 );
//     }
//     return (
//         <div>
//             {active ? "active" : "inactive"}
//             <div className="toggle-el" onClick={toggle}>
//
//                 <div key={12143+Date.now()}>
//                     {active ? (
//                         <Anime
//                             key={1221+Date.now()}
//                             easing="linear"
//                             loop={false}
//                             autoplay={true}
//                             duration={1000}
//                             delay={(el, index) => index * 240}
//                             translateX="2rem"
//
//                         >
//                             <div className=" notch ">
//                                 <span> 11111</span></div>
//                         </Anime>
//                     ) : (
//
//                         <Anime
//                             key={11+Date.now()}
//                             easing="linear"
//                             loop={false}
//                             autoplay={true}
//                             duration={1000}
//                             delay={(el, index) => index * 240}
//                             translateX={active ? "2rem" : "-0.1rem"}
//
//                         >
//                             <div className=" notch ">
//                                 <span> 2222</span></div>
//                         </Anime>
//                     )
//                     }
//
//                 </div>
//             </div>
//         </div>
//     )
// }
//
//
// export default Toggle;
